// src/api/publicationService.ts
import api from './config';

export interface Publication {
  id?: number;
  title: string;
  year: number;
  link?: string;
  // Add any other fields your publication entity has
}

export const getPublications = async (): Promise<Publication[]> => {
  const response = await api.get('/api/publications');
  return response.data.data;
};

export const getPublicationById = async (id: number): Promise<Publication> => {
  const response = await api.get(`/api/publications/${id}`);
  return response.data.data;
};

// Add CRUD operations if needed for admin functionality
export const createPublication = async (publication: Omit<Publication, 'id'>): Promise<Publication> => {
  const response = await api.post('/api/publications', publication);
  return response.data.data;
};

export const updatePublication = async (id: number, publication: Partial<Publication>): Promise<Publication> => {
  const response = await api.put(`/api/publications/${id}`, publication);
  return response.data.data;
};

export const deletePublication = async (id: number): Promise<void> => {
  await api.delete(`/api/publications/${id}`);
};
